import type { ReactElement } from 'react';
import React from 'react';
import { ErrorBoundary } from 'atom-components/error-boundary/error-boundary';
import Loading from 'atom-components/loading';

const Routes = React.lazy(() =>
  import(/* webpackChunkName: "clusters" */ './routes').then((module) => ({
    default: module.default
  }))
);

export default function ClustersGateway(): ReactElement {
  return (
    <ErrorBoundary>
      <React.Suspense fallback={<Loading />}>
        <Routes />
      </React.Suspense>
    </ErrorBoundary>
  );
}
